// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3aaGt","head":"Table_head__3K4wn","col":"Table_col__qd-3S"};